export default __webpack_public_path__ + "static/media/more.f2fbb9bd.svg";